module.exports = __webpack_public_path__ + "img/facebook.faee49ff.svg";